export const copy = {
  actionButton: {
    label: "Get started",
  },
};
